import { handleTouchEvents } from '../../utilities/touchEvent'

document.addEventListener('DOMContentLoaded', () => {
  handleTouchEvents('[data-mp-block-layout="trending-carousel"] .block__main')
})
